import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { DeleteWrapper, DeleteButton } from "../../styles";
import API from "../../../../axios/instances/API";
import { FEEDBACK_MESSAGES } from "../../../../storage/constants";
import { Alert, Typography } from "@mui/material";
import { PATHS } from "src/routes";

const ConfirmDeleteTeamMember = ({ deleteInfo, endpoint }) => {
  const [isdeleting, setIsDeleting] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [hasDeleted, setHasDeleted] = useState(false);
  const history = useHistory();

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await API.delete(endpoint, {
        data: {
          id: deleteInfo.id,
        },
      });
      setIsDeleting(false);
      setHasDeleted(true);
      setTimeout(() => {
        history.push(PATHS.TEAM_MEMBERS);
      }, 2400);
    } catch (error) {
      setErrorAlert(true);
      setIsDeleting(false);
    }
  };

  return (
    <DeleteWrapper style={{ border: "1px solid tomato", width: 460 }}>
      {hasDeleted ? (
        <Alert my={6}>
          Team member successfully deleted, you will be redirected to the team
          member page
        </Alert>
      ) : (
        <>
          <Typography variant="h5" component="h5">
            Remove team member?
          </Typography>
          <Typography sx={{ mb: 6 }} variant="subtitle1">
            {deleteInfo?.name}
          </Typography>
          <DeleteButton fullWidth disabled={isdeleting} onClick={handleDelete}>
            {isdeleting ? "..." : "Confirm"}
          </DeleteButton>
          {errorAlert && (
            <Alert
              sx={{ mt: 4 }}
              severity="error"
              onClose={() => setErrorAlert(false)}
            >
              {FEEDBACK_MESSAGES.GENERIC_ERROR}
            </Alert>
          )}
        </>
      )}
    </DeleteWrapper>
  );
};

export default ConfirmDeleteTeamMember;
